<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  .el-messageBox {
    width: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue